export enum MtplPurpose {
    Default = 'NEPADID',
}
